/* 布局 */
//前台
import Layout from "@views/layout";

const plaparcurriculumclassRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plaparcurriculumclass/list",
        name: "PLAPARCURRICULUMCLASS",
        meta: {
            title: "家长课程分类",
        },
        component: () => import("@views/business/plaparcurriculumclass/index.vue"),
    },
        ],
};

export default plaparcurriculumclassRouter;
